const FOCUSABLE_SELECTOR = ["a[href]", "button", "input", "select", "textarea", "[tabindex]"].join(",");

type FocusCandidate = HTMLElement & { readonly disabled?: boolean; readonly type?: string };

function isFocusable(candidate: FocusCandidate): boolean {
  if (candidate.disabled || candidate.hidden || candidate.type === "hidden") {
    return false;
  }

  return candidate.tabIndex >= 0;
}

export default function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<FocusCandidate>(FOCUSABLE_SELECTOR)).filter(isFocusable);
}
